import { addSuppressedu5jwjfvsc039 as addSuppressed } from '../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { unwrap34f7x4f5snsxt as unwrap } from '../internal/StackTraceRecovery.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Key_instance2rlngjw9v1qsd as Key_instance } from '../Job.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from './FlowCollector.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_ONEazvfdh9ju3d4 as get_ONE } from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/boxedLong/boxedLong.mjs';
import { add2suhfggl4zvkk as add } from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function catch_0(_this__u8e3s4, action) {
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  return new (catch$$inlined$unsafeFlow$1())(_this__u8e3s4, action);
}
function *catchImpl(_this__u8e3s4, collector, $completion) {
  var fromDownstream = {_v: null};
  try {
    var tmp = catchImpl$slambda_0(collector, fromDownstream);
    yield* _this__u8e3s4.a1d(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp), $completion);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      var fromDownstream_0 = fromDownstream._v;
      var tmp_0;
      if (isSameExceptionAs(e, fromDownstream_0)) {
        tmp_0 = true;
      } else {
        // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
        // Inline function 'kotlin.js.getCoroutineContext' call
        var tmp$ret$0 = $completion.mc();
        tmp_0 = isCancellationCause(e, tmp$ret$0);
      }
      if (tmp_0) {
        throw e;
      } else {
        if (fromDownstream_0 == null) {
          return e;
        }
        if (e instanceof CancellationException()) {
          addSuppressed(fromDownstream_0, e);
          throw fromDownstream_0;
        } else {
          addSuppressed(e, fromDownstream_0);
          throw e;
        }
      }
    } else {
      throw $p;
    }
  }
  return null;
}
function isSameExceptionAs(_this__u8e3s4, other) {
  return !(other == null) && equals(unwrap(other), unwrap(_this__u8e3s4));
}
function isCancellationCause(_this__u8e3s4, coroutineContext) {
  var job = coroutineContext.yc(Key_instance);
  if (job == null || !job.ax())
    return false;
  return isSameExceptionAs(_this__u8e3s4, job.dx());
}
function retryWhen(_this__u8e3s4, predicate) {
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  return new (retryWhen$$inlined$unsafeFlow$1())(_this__u8e3s4, predicate);
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.g1h_1 = function_0;
      }
      *s1d(value, $completion) {
        return yield* this.g1h_1(value, $completion);
      }
      i5() {
        return this.g1h_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i5(), other.i5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i5());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
var catch$$inlined$unsafeFlow$1Class;
function catch$$inlined$unsafeFlow$1() {
  if (catch$$inlined$unsafeFlow$1Class === VOID) {
    class $ {
      constructor($this_catch, $action) {
        this.h1h_1 = $this_catch;
        this.i1h_1 = $action;
      }
      *r1d(collector, $completion) {
        var exception = yield* /*#__NOINLINE__*/catchImpl(this.h1h_1, collector, $completion);
        if (!(exception == null))
          yield* this.i1h_1(collector, exception, $completion);
        return Unit_instance;
      }
      a1d(collector, $completion) {
        return this.r1d(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    catch$$inlined$unsafeFlow$1Class = $;
  }
  return catch$$inlined$unsafeFlow$1Class;
}
var catchImpl$slambdaClass;
function catchImpl$slambda() {
  if (catchImpl$slambdaClass === VOID) {
    class $ {
      constructor($collector, $fromDownstream) {
        this.j1h_1 = $collector;
        this.k1h_1 = $fromDownstream;
      }
      *p1g(it, $completion) {
        try {
          yield* this.j1h_1.s1d(it, $completion);
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            this.k1h_1._v = e;
            throw e;
          } else {
            throw $p;
          }
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.p1g(p1, $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    catchImpl$slambdaClass = $;
  }
  return catchImpl$slambdaClass;
}
function catchImpl$slambda_0($collector, $fromDownstream) {
  var i = new (catchImpl$slambda())($collector, $fromDownstream);
  var l = (it, $completion) => i.p1g(it, $completion);
  l.$arity = 1;
  return l;
}
var retryWhen$$inlined$unsafeFlow$1Class;
function retryWhen$$inlined$unsafeFlow$1() {
  if (retryWhen$$inlined$unsafeFlow$1Class === VOID) {
    class $ {
      constructor($this_retryWhen, $predicate) {
        this.l1h_1 = $this_retryWhen;
        this.m1h_1 = $predicate;
      }
      *r1d(collector, $completion) {
        var attempt = 0n;
        var shallRetry;
        do {
          shallRetry = false;
          var cause = yield* /*#__NOINLINE__*/catchImpl(this.l1h_1, collector, $completion);
          if (!(cause == null)) {
            if (yield* this.m1h_1(collector, cause, attempt, $completion)) {
              shallRetry = true;
              var _unary__edvuaz = attempt;
              attempt = add(_unary__edvuaz, get_ONE());
            } else {
              throw cause;
            }
          }
        }
         while (shallRetry);
        return Unit_instance;
      }
      a1d(collector, $completion) {
        return this.r1d(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    retryWhen$$inlined$unsafeFlow$1Class = $;
  }
  return retryWhen$$inlined$unsafeFlow$1Class;
}
//region block: exports
export {
  catch_0 as catchrcnx5mlu3pkp,
  retryWhen as retryWhenf2aqzvtrvxoo,
};
//endregion

//# sourceMappingURL=Errors.mjs.map
